import classNames from 'classnames';
import Button from '../Button';
import ContentBlock from '../ContentBlock';
import FlexContainer from '../FlexContainer';
import Txt from '../Txt';
import styles from './InfoActionHeader.module.scss';

/**
 * InfoActionHeader
 *
 * @return {JSX.Element}
 */
const InfoActionHeader = ({
  className,
  children,
  action,
  items,
  actionTitle,
}) => {
  return (
    <ContentBlock
      className={classNames(
        styles.InfoActionHeader,
        className,
        `${InfoActionHeader.displayName}`
      )}
      spaceBetween
      gap
      alignCenter
    >
      <FlexContainer gap overflow alignCenter className={styles.InfoBlock}>
        {children
          ? children
          : items
          ? items.map(({ key, label, value }) => (
              <FlexContainer key={key} gapQuad alignCenter>
                <Txt bold x>
                  {value}
                </Txt>
                <Txt className="label" regular>
                  {label}
                </Txt>
              </FlexContainer>
            ))
          : null}
      </FlexContainer>
      {action ? (
        <FlexContainer gap>
          <Button success onClick={action}>
            {actionTitle}
          </Button>
        </FlexContainer>
      ) : null}
    </ContentBlock>
  );
};

InfoActionHeader.displayName = 'InfoActionHeader';

export default InfoActionHeader;
